<template>
  <div>
       خرید دوره
  </div>
</template>

<script>
export default {
  name: "CourseBuyDesktop"
}
</script>

<style scoped>

</style>